import React, { useContext, useState } from "react";
import cx from "classnames";
import { Icon } from "@foris/avocado-icons";
import { TextField } from "@foris/avocado-suite";
import { Types as EditionTypes } from "../../context/editions.reducer";
import { Context } from "../../context/GroupsManagerContext";
import css from "./multiCapacityInput.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  disabled: boolean;
  getGroupIdsToExclude: Set<string>;
}

const MultiCapacityInput: React.FC<Props> = ({ disabled, getGroupIdsToExclude }) => {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(Context);
  const [inputValue, setInputValue] = useState<string | number>("");

  const onChange = (e: any) => {
    setInputValue(e?.target?.value);
  };

  const onBlur = () => {
    const value = inputValue?.toString();
    setInputValue(value);

    if (value === "") {
      dispatch({ type: EditionTypes.RestoreGroupsToEditCapacities });
    } else {
      setInputValue("");
      dispatch({
        type: EditionTypes.EditGroupsToEditCapacities,
        payload: {
          capacity: (value as unknown) as number,
          groupIdsToExclude: getGroupIdsToExclude,
          groupsById: state?.data?.groupsById,
        },
      });
    }

    dispatch({ type: EditionTypes.SetGroupsToEdit, payload: {} });
  };

  return (
    <div className={cx(css.multyCapacityInput, disabled && css.multyCapacityInput__disabled)}>
      <span className={css.multyCapacityInput_label}>
        <Icon name="edit" color={disabled ? "neutral-50" : "neutral-70"} />
        {t("groups-manager.groups-table.actions.edit-capacity")}
      </span>

      <TextField
        className={css.multyCapacityInput_input}
        value={inputValue}
        disabled={disabled}
        onChange={onChange}
        type="number"
        onBlur={onBlur}
        onFocus={() => {
          setInputValue("");
        }}
      />
    </div>
  );
};

export default MultiCapacityInput;
